import React from "react"
import { OutlinedButton, ValidationError } from "dash-styled"
import { ReactComponent as AddIcon } from "icons/lib/plus.svg"

import { DocumentType } from "../../../../../Models/DataProgram/DocumentExtraction"
import { DocumentModal } from "../Common/Modals/DocumentModal"
import {
    DocumentsListProps,
    useDocumentsList
} from "../Common/Hooks/useDocumentsList"
import { DocumentsListItem } from "./DocumentsListItem"

export const DocumentsList = (props: DocumentsListProps) => {
    const {
        newDocumentView: [isOpen, open, close],
        documentsSchema,
        documentsErrors,
        documents,
        onDocumentAdd,
        onDocumentEdit,
        onDocumentDelete
    } = useDocumentsList(props)

    return (
        <>
            {documents.length === 0 && (
                <OutlinedButton
                    testId="add-new-document"
                    label="Add new document"
                    Icon={AddIcon}
                    className="bg-grape-500 hover:bg-grape-300 text-white rounded-lg py-3 my-4"
                    onClick={open}
                />
            )}
            {documentsErrors?.__errors?.[0] && (
                <ValidationError className="mr-1">
                    {documentsErrors?.__errors?.[0]}
                </ValidationError>
            )}
            {documents
                .filter((doc: DocumentType) => doc !== undefined)
                ?.map((document: DocumentType, index: number) => (
                    <React.Fragment key={`${document?.documentType}_${index}`}>
                        <DocumentsListItem
                            schema={documentsSchema}
                            value={document}
                            onDelete={onDocumentDelete(index)}
                            onEdit={onDocumentEdit(index)}
                        />
                        {documentsErrors?.[index] && (
                            <ValidationError className="mr-1 mb-4">
                                {
                                    documentsErrors?.[index]?.annotationFields
                                        ?.__errors?.[0]
                                }
                            </ValidationError>
                        )}
                    </React.Fragment>
                ))}
            {isOpen && (
                <DocumentModal
                    schema={documentsSchema}
                    onSubmit={onDocumentAdd}
                    onClose={close}
                />
            )}
        </>
    )
}
